// extracted by mini-css-extract-plugin
module.exports = {"box":"box--u-TJk","boxImage":"boxImage--CVKtl"};